const components = {
    FormLabel: {
        baseStyle: {
            color: '#9EA5AB',
            fontWeight: 400,
            fontSize: '14px',
            lineHeight: '20px',
        },
    },
};

export default components;